import { Header } from "@components/layout/header/index";
import Footer from "@components/layout/footer";
import { Outlet } from "react-router-dom";

const PublicRoute = () => {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Header />

      <main className="flex-grow-1 pt-0 mt-0">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default PublicRoute;
